import React, { useEffect } from "react";
import { Badge, Stack } from "react-bootstrap";

const UseBadge = ({
  field,
  register,
  setValue,
  disable,
  options,
  direction,
  gap,
  pillClass,
}) => {
  useEffect(() => {
    register(field);
  }, [field, register]);

  function handleClick(badge) {
    setValue(field, badge);
  }

  return (
    <div>
      <Stack direction={direction} gap={Number(gap) || 2}>
        {options?.map((option, index) => (
          <Badge
            pill
            bg={option.bg}
            className={pillClass}
            key={index}
            role="button"
            onClick={() => handleClick(option.title)}
          >
            {option.title}
          </Badge>
        ))}
      </Stack>
    </div>
  );
};

export default UseBadge;
